import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  item: {
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '15px 30px 5px 30px',
    '& .MuiFormHelperText-contained': {
      margin: '0',
    },
  },
  helperRow: {
    height: '15px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  fieldLimits: {
    textAlign: 'right',
    color: '#2C2D3E',
  },
  error: {
    color: 'red',
  },
  htmlContentSize:{
    fontSize: '12px',
    fontFamily: 'Roboto',
    textAlign: 'right',
  },
  answerTooLong:{
    color: 'red',
    fontSize: '12px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between',
  },
  showHtml:{
    padding: '0 30px 0 0',
  }
}));
